<!-- 轨迹详情列表组件 -->
<template>
  <div style="height:calc(89vh)"
       id="pageInfo">
    <div style="height:calc(28vh);">
      <div style="margin:10px;cursor:pointer;padding-top:5px"
           @click="back"
           class="iconfont-lunan icon-lunan-uf-icon-back1">返回</div>
      <div style="margin:20px 0 10px 15px;">人员信息</div>
      <div class="searchList">
        <div style="flex:1;">
          <img :src="imgPath(nowPersonInfo)"
               class="image"
               onerror="this.src='/images/theme/newDark/default.png'"
               style="width:110px;height:110px">
        </div>
        <div style="flex:3;">
          <div style="margin:10px;color:#fff;padding-left:5px">
            <span style="color:#95a6c1">姓名： </span>
            <span>{{ nowPersonInfo.name ? nowPersonInfo.name : '未知人员' }}</span>
          </div>
          <div style="margin:10px;color:#fff;padding-left:5px">
            <span style="color:#95a6c1">手机号： </span>
            <span>{{nowPersonInfo.phone}}</span>
          </div>
          <div style="margin:10px;color:#fff;padding-left:5px;display:flex">
            <span style="color:#95a6c1;">名单组： </span>
            <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;width:100px;">{{nowPersonInfo.faceSetName}}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin:5px 15px;">行走轨迹</div>
    <div style="height:calc(50vh);overflow:auto">
      <div v-for="(item,index) in personDataList"
           :key="index"
           @click.stop="getTrajectory(item,index)"
           :class="['trajectoryId'+index,'trajectoryList']">
        <div style="display:flex;justify-content:space-between;width:100%;padding:0 10px;font-size:12px">
          <div>
            <span>时间：</span>
            <span>{{item.recordDate}}</span>
          </div>
          <span :class="item.isPeopleShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></span>
        </div>
        <div v-for="(val,indexIner) in item.points[0]"
             :key="indexIner"
             :class="'trackPerson-detail '+(item.isPeopleShow ? 'expand' : 'collspand')">
          <div v-if="indexIner<moreList[index]['flg']"
               style="width:100%">
            <div class="trackPerson-detail-img"
                 :key="key">
              <img :src="val.face_img_url"
                   @click.stop="handlePositon(val)"
                   onerror="this.src='/images/theme/newDark/default.png'">
              <input type="checkbox"
                     :name="item.recordDate+indexIner"
                     @click.stop="handleCheckedChange($event,val,item.recordDate,indexIner)"
                     style="position:absolute;top:5px;right:5px">
            </div>
            <!-- <div style="text-align:center;margin-top:10px;font-size:12px">
              <span>相似度：</span>
              <span>{{val.similarity}}</span>
            </div> -->
            <div style="text-align:center;font-size:12px">
              <span>时间：</span>
              <span>{{val.recordTime4Sort.trim().split(" ")[1]}}</span>
            </div>
          </div>
        </div>
        <div v-if="moreList[index]['length']>moreList[index]['flg']"
             :class="'more-list '+(item.isPeopleShow ? 'expand' : 'collspand')"
             @click.stop="getMoreList(index)">
          <el-button size="mini"
                     type="primary">查看更多</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dates, Bus } from '$utils'
// import miniPlayer from '@components/mini-player/mini-player.vue'

export default {
  props: {
    // nowPersonInfo: {
    //   type: Object,
    //   default: () => { return {} }
    // },
    // personDataList: {
    //   type: Array,
    //   default: () => { return [] }
    // }
  },
  components: {
    // miniPlayer
  },
  mounted () {
  },
  watch: {
    // checkboxGroupList: {
    //   handler (newValue, oldValue) {
    //     console.log('watch执行')
    //     // 去勾选所有复选框
    //     $("input[type=checkbox]").prop("checked", false);
    //     this.copyCheckboxGroupList = [];
    //     // $("input[name='"+this.inputName+"'").prop('checked',true);
    //     console.log('this.inputName_watch', this.inputName);
    //   },
    //   deep: true
    // }
  },
  data () {
    return {
      key: 1,
      copyCheckboxGroupList: [],
      checkIdList: [],
      checkboxGroupList: [],
      personDataList: [],
      moreList: [],
      nowPersonInfo: {}
    }
  },
  methods: {
    handlePositon (val) {
      this.$map.MapInstance2D.setMapCenter([val.lng, val.lat])
    },
    imgPath (item) {
      return item ? Bus.imgPath(item.fileCode) : ""
    },
    getMoreList (index) {
      this.moreList[index]['flg'] += 4;
    },
    getTrajectory (item, id) {
      this.TrackImgShow(id)
      this.copyCheckboxGroupList = []
      this.checkIdList = []
      console.log('item', item)
      let domId = 'trajectoryId' + id
      console.log('id', 'trajectoryId' + id)
      let allBorder = document.getElementsByClassName('trajectoryList')
      let changeBorder = document.getElementsByClassName(domId)[0]
      for (let i = 0; i < allBorder.length; i++) {
        allBorder[i].style.border = 'none'
      }
      this.showDrawTrajectory(item.points[0])
      // 移除地图轨迹
      this.key += 1
    },
    handleCheckedChange (event, val, date, index) {
      let name_ = date + index
      let checkboxFlag = document.getElementsByName(name_)
      console.log('checkboxFlag[0].checked', checkboxFlag[0].checked, val)
      if (checkboxFlag[0].checked) {
        // 选中
        this.copyCheckboxGroupList.push(val)
        this.checkIdList.push(val.recordTime)
      } else {
        // 取消选中
        let spliceIndex = this.checkIdList.indexOf(val.recordTime)
        this.copyCheckboxGroupList.splice(spliceIndex, 1)
        this.checkIdList.splice(spliceIndex, 1)
      }
      this.showDrawTrajectory(this.copyCheckboxGroupList)
    },
    // 绘制轨迹信息 气泡yhjadd
    showDrawTrajectory (item) {
      let drawItem = JSON.parse(JSON.stringify(item))
      // 时间排序
      drawItem.sort((a, b) => {
        var x = 'recordTime'
        var value1 = a[x];
        var value2 = b[x];
        return value1 - value2;
      })
      // 移除地图轨迹
      this.$map.MapInstance2D.removeTrajectory()
      this.$map.MapInstance2D.closeTips()
      // 设置地图点位
      let setPoint = []
      let src = ''
      //合并相同项
      let dataInfo = {};
      drawItem.forEach((data, index) => {
        // data.startTime = data.startTime * 1000
        // data.endTime = data.endTime * 1000
        let { lng } = data;
        let { lat } = data;
        if (!dataInfo[lng] && !dataInfo[lat]) {
          dataInfo[lng] = {
            data,
            child: []
          }
        }
        dataInfo[lng].child.push(data);
      });
      let list = Object.values(dataInfo);
      list.map((val, index) => {
        if (index === 0) {
          src = './images/theme/newDark/map/state.png'
        } else if (index === (list.length - 1)) {
          src = './images/theme/newDark/map/end_point.png'
        } else {
          src = './images/theme/newDark/map/finish_click.png'
        }
        setPoint.push({
          point: (() => {
            let ary = []
            ary.push(val.data.lng)
            ary.push(val.data.lat)
            ary.push(src)
            ary.push(val.child.length > 1 ? val.child : val.child[0])
            return ary
          })(val),
        })
      })
      setPoint.length ?
        this.$map.MapInstance2D.setMapCenter(setPoint[setPoint.length - 1].point) :
        this.$map.MapInstance2D.setMapCenter()
      // this.$map.MapInstance2D.setMapOption()
      this.$map.MapInstance2D.drawTrajectory(setPoint, 1)
    },
    TrackImgShow (index) {
      let isPeopleShow = this.personDataList[index].isPeopleShow;
      this.personDataList.map(val => {
        val.isPeopleShow = false
      })
      this.personDataList[index].isPeopleShow = !isPeopleShow;
      this.moreList[index]['flg'] = 4;
    },
    changeCheckbox (ev, data, date, index) {
      if (this.copyCheckboxGroupList.length == 0) {
        this.copyCheckboxGroupList = JSON.parse(JSON.stringify(this.checkboxGroupList.trailList));
      }
      let name_ = date + index;
      this.inputName = name_;
      let checkboxFlag = document.getElementsByName(name_);
      console.log('checkboxFlag[0].checked', checkboxFlag[0].checked)
      console.log('this.copyCheckboxGroupList_start', this.copyCheckboxGroupList);
      if (checkboxFlag[0].checked) {
        // 选中去除
        console.log('执行去除')
        this.copyCheckboxGroupList.map((val, index) => {
          if (val.id === data.id) {
            this.copyCheckboxGroupList.splice(index, 1);
            this.copyCheckboxGroupListIndex = index;
          }
        })
      } else {
        if (this.copyCheckboxGroupListIndex != 0) {
          this.copyCheckboxGroupList.splice(this.copyCheckboxGroupListIndex, 0, data)
        } else {
          this.copyCheckboxGroupList.unshift(data)
        }
      }
      console.log('this.copyCheckboxGroupList_end', this.copyCheckboxGroupList)
    },
    back () {
      this.personDataList = [];
      this.$parent.main = true;
      this.carDetailsList = [];
      this.$map.MapInstance2D.removeTrajectory()
      this.$map.MapInstance2D.initPage();
    },
  }
}
</script>

<style lang='scss'>
</style>
